import { isNil } from "lodash";

import { useUpdate } from "../../../hooks/useUpdate";
import { isObject } from "../../../utils/isObject";
import { isConditionSpecialFunc } from "../../../utils/isConditionSpecialFunc";
import { checkEmptyOrFilled } from "../../../utils/checkEmptyOrFilled";

import { FilterCondition } from "../../../evergis/core/condition/FilterCondition";
import { FilterConditionOperation, FilterConditionType } from "../types";
import { FilterConditionUpdate } from "./useFilterConditions";

export const DevModeEffects = {
  useRawCondition: (trigger: boolean, condition: string, update: FilterConditionUpdate) => {
    useUpdate(() => {
      if (trigger) {
        const filterCondition = new FilterCondition(condition);

        if (filterCondition.isParsingError()) {
          update.setConditions([]);
          update.setConditionOperation(FilterConditionOperation.AND);
        } else {
          const newConditions = filterCondition.conditions;

          update.setConditions(newConditions);
          update.setConditionOperation(filterCondition.conditionOperation || FilterConditionOperation.AND);
        }
      }
    }, [trigger]);
  },
  useConditions: (
    trigger: boolean,
    conditions: FilterConditionType[],
    conditionOperation: FilterConditionOperation,
    update: FilterConditionUpdate,
    rawCondition: string | null,
  ) => {
    useUpdate(() => {
      if (trigger && conditions?.length) {
        const isSpecialFunc = isConditionSpecialFunc(rawCondition);

        if (isSpecialFunc) {
          update.setRawCondition(rawCondition || "");
        } else {
          const filledConditions = conditions.filter(checkConditionFilled);
          const newCondition = FilterCondition.from(filledConditions, conditionOperation).toString();
          const isComplex =
            filledConditions.filter(condition => isObject(condition.attribute) || isObject(condition.value)).length > 0;

          update.setRawCondition((isComplex ? rawCondition : newCondition) || "");
        }
      }
    }, [trigger]);
  },
};

export function checkConditionFilled({ attribute, comparisonOperator, value }: FilterConditionType): boolean {
  return attribute !== null && (checkEmptyOrFilled(comparisonOperator) || !isNil(value));
}

export function checkConditionUnfilled(condition: FilterConditionType): boolean {
  return !checkConditionFilled(condition);
}
